module.exports = __webpack_public_path__ + "d0e38d3650d3401f3a58d423dfaf2cdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-jormat-home.png
// module id = 106
// module chunks = 0